import { ReactNode } from "react";
import styles from "./BpsPageHeader.module.scss";
import { BackIcon } from "../../../../assets/icons";
import SearchInput from "../../xepp/search-input/SearchInput";

interface BpsPageHeaderProps {
	title: string;
	/** Renders a back button to the left of the title when provided. */
	onBack?: () => void;
	/** Primary action rendered on the right, e.g. a "New …" / "Save" button. */
	action?: ReactNode;
	/** Renders a search field under the title row when provided. */
	onSearch?: (value: string) => void;
	searchPlaceholder?: string;
}

/** Title bar of the BPS admin screens — used by list pages, forms and detail views. */
export function BpsPageHeader({ title, onBack, action, onSearch, searchPlaceholder }: Readonly<BpsPageHeaderProps>) {
	return (
		<>
			<div className={styles.header}>
				<div className={styles.titleGroup}>
					{onBack && (
						<button type="button" title="Go back" className={styles.backButton} onClick={onBack}>
							<BackIcon />
						</button>
					)}
					<h2 className={styles.title}>{title}</h2>
				</div>
				{action}
			</div>

			{onSearch && (
				<div className={styles.searchRow}>
					<div className={styles.searchBox}>
						<SearchInput placeholder={searchPlaceholder} onSearch={onSearch} />
					</div>
				</div>
			)}
		</>
	);
}
